import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as sessionActions from 'redux/modules/sessions';
import { isLoaded as areSessionsLoaded, load as loadSessions } from 'redux/modules/sessions';
import { initializeWithKey } from 'redux-form';
import { asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
var _ = require('underscore');

import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];

    if (!areSessionsLoaded(getState())) {
      promises.push(dispatch(loadSessions(params)));
    }

    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    sessions: state.sessions.data,
    editing: state.sessions.editing,
    error: state.sessions.error,
    loading: state.sessions.loading,
    sending: state.sessions.sending,
  }),
  { ...sessionActions, initializeWithKey })

export default class Sessions extends Component {

  render() {

    const { sessions, error, editing, loading, load, sending, t } = this.props;
    let refreshClassName = 'fa fa-refresh';
    let refreshSCC = 'fa fa-refresh';

    if (loading) {
      refreshClassName += ' fa-spin';
    }

    const styles = require('./Sessions.scss');

    var sessions_rows = [];

    _.each(sessions, (session) => {
      sessions_rows.push(
        <tr>

          <td>{session.date}</td>
          <td>{session.username}</td>
          <td>{session.user_role}</td>
          <td style={{ width: '30%' }}>{session.user_agent}</td>
          <td>{session.ip}</td>
        </tr>
      )
    });

    return (
      <div className={styles.sessions + ' container'}>
        <h1>
          Sessions &nbsp;
          <button className={styles.refreshBtn + ' btn btn-success'} onClick={load}>
            <i className={refreshClassName} /> {' '} {t("sessions.reload_sessions")}
          </button>
        </h1>
        <Helmet title="Sessions" />
        {error &&
          <div className="alert alert-danger" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            {' '}
            {t("main.connection_error")}
          </div>}
        {sessions && _.size(sessions) > 0 &&
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t("sessions.connected_since")}</th>
                <th>Login</th>
                <th>Role</th>
                <th>User Agent</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {sessions_rows}
            </tbody>
          </table>}
      </div>
    );
  }
}




